
import { useStore } from 'vuex'
import { List } from 'vant'
import { getPersonInfo } from '@/api/person'
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

// 获取信息
const useInfoEffect = () => {
  const userInfo = reactive({
    nickName: '',
    headImg: '',
  })
  const recordList = ref([])
  const listQuery = reactive({
    offset: 1,
    pageSize: 10,
  })
  const loadQuery = reactive({
    loading: true,
    finished: false,
  })
  const store = useStore()
  const getInfo = async () => {
    try {
      const result = await getPersonInfo({
        ...listQuery,
        token: store.getters.getToken,
      })

      if (result.ok) {
        userInfo.nickName = result?.dataMap?.nickName
        userInfo.headImg = result?.dataMap?.headImg
        recordList.value = [...recordList.value, ...result?.data.rows]
        loadQuery.loading = false
        listQuery.offset++
        // 数据全部加载完成
        if (recordList.value.length >= result?.data.total) {
          loadQuery.finished = true
        }
      }
    } catch (error) {
      loadQuery.loading = false
      loadQuery.finished = true
    }
  }

  return {
    userInfo,
    recordList,
    loadQuery,
    getInfo,
  }
}

// 列表点击事件
const useListClickEffect = () => {
  const router = useRouter()

  const handleJump2Detail = (item) => {
    if (item.type === 1) {
      router.push(`/person/record?questionActiveKey=${item.questionActiveKey}`)
    } else {
      router.push(
        `/person/rank?questionActiveKey=${item.questionActiveKey}&title=${item.title}`
      )
    }
  }

  return {
    handleJump2Detail,
  }
}

export default {
  components: {
    List,
  },
  setup() {
    const { userInfo, recordList, getInfo, loadQuery } = useInfoEffect()

    const { handleJump2Detail } = useListClickEffect()

    return {
      userInfo,
      loadQuery,
      recordList,
      handleJump2Detail,
      getInfo,
    }
  },
}
